import { connect } from 'react-redux';
import Result from './Result';
import timeDepositActions from '../../../../../store/actions/timeDeposit.action';
import userActions from '../../../../../store/actions/user.action';
import accountActions from '../../../../../store/actions/account.action';
import challengeActions from '../../../../../store/actions/challenge.action';
import appModalActions from '../../../../../store/actions/appModal.action';
import googleAnalytics from '../../../../../store/actions/googleAnalytics.action';


const mapStateToProps = state => ({
  step: state.simulation.step,
  amount: state.simulation.amount,
  resultSelected: state.simulation.resultSelected,
  accounts: state.account.list,
  accountOut: state.simulation.accountOut,
  accountIn: state.simulation.accountIn,
  termsAccepted: state.simulation.termsAccepted,
  email: state.user.email,
  isLoading: state.account.loading,
  challenges: state.challenge.challenges,
  invertible: state.simulation.result.invertible,
  primerNombre: state.user.primerNombre,
  apellidoPaterno: state.user.apellidoPaterno,
  genero: state.user.genero,
  unexpectedError: state.account.unexpectedError, 
  updatingAccounts: state.account.updatingAccounts,
  available: state.account.available,
  montoLimitDap: state.simulation.montoLimitDap
});

const mapDispatchToProps = dispatch => {
  return {
    setStep: step => {
      dispatch(timeDepositActions.setStep(step));
    },
    changeTerms: check => {
      dispatch(timeDepositActions.changeTerms(check));
    },
    getAccounts: (showLoading = true) => {
      dispatch(accountActions.getAccounts('SIGHT', showLoading));
    },
    changeAccountOut: account => {
      dispatch(timeDepositActions.changeAccountOut(account));
    },
    changeAccountIn: account => {
      dispatch(timeDepositActions.changeAccountIn(account));
    },
    contractTimeDeposit: params => {
      dispatch(timeDepositActions.contractTimeDeposit(params));
    },
    changeEmail: email => {
      dispatch(userActions.changeEmail(email));
    },
    getChallenge: id => {
      dispatch(challengeActions.getChallenges(id));
    },
    cleanResult: () => {
      dispatch(timeDepositActions.cleanResult());
    },
    openErrorModal: (message) => {
      dispatch(appModalActions.openErrorModal(message));
    },
    setSimulationSelected: simulationSelected => {
      dispatch(timeDepositActions.setSimulationSelected(simulationSelected));
    },
    validate: () => {
      dispatch(accountActions.validate());
    },
    googleAnalytics: (params) => {
      googleAnalytics.registerGoogleAnalytics(params);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Result);
